module.exports = __webpack_public_path__ + "img/MAGAZINE LOADER (90˚ Type).33c76408.jpg";